module.exports = __webpack_public_path__ + "img/FI17745359.1faabed3.png";